/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const ChannelPspR = t.interface({
  business_name: t.string,

  enabled: t.boolean,

  payment_types: t.readonlyArray(t.string, "array of string"),

  psp_code: t.string,

  tax_code: t.string
});

// optional attributes
const ChannelPspO = t.partial({});

export const ChannelPsp = t.intersection(
  [ChannelPspR, ChannelPspO],
  "ChannelPsp"
);

export type ChannelPsp = t.TypeOf<typeof ChannelPsp>;
